export enum OrganizationUserStatusType {
    Invited = 0,
    Accepted = 1,
    Confirmed = 2,
}
